import type {
  CustomerFundChangeListItem,
  CustomerFundChangeListParams,
  CustomerFundChangeListResponse,
  CustomerFundChangeTrendItem,
  CustomerFundChangeTrendParams,
} from './types/customer-fund-change'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { DateRanges } from '#/utils'

export const customerFundChangeApi = defineApi('operation', ({ prefix }) => {
  function getCustomerFundChangeListParams(
    params: CustomerFundChangeListParams,
  ) {
    return {
      condition: {
        dateRange: DateRanges.datesOrNull(params.condition.dateRange),
        customerId: params.condition.customerId,
        companyName: params.condition.companyName,
      },
      sortBy: params.sortBy,
      orderBy: params.orderBy,
    }
  }

  function getCustomerFundChangeList(
    params: PagingRequest<CustomerFundChangeListParams>,
  ) {
    return requestClient
      .post<CustomerFundChangeListResponse>(
        prefix('customerFundChangeDaily/query'),
        {
          pageIndex: params.pageIndex,
          pageSize: params.pageSize,
          sortBy: params.sortBy,
          orderBy: params.orderBy,
          condition: params.condition,
        },
      )
      .then((apiResponse) => {
        return {
          items:
            apiResponse.list?.map(
              (fundChangeItem: CustomerFundChangeListItem) => {
                return {
                  customerId: fundChangeItem.customerId,
                  companyName: fundChangeItem.companyName,
                  totalAssetNetValue: fundChangeItem.totalAssetNetValue,
                  walletChangeAmount: fundChangeItem.walletChangeAmount,
                  walletBalance: fundChangeItem.walletBalance,
                  depositAmount: fundChangeItem.depositAmount,
                  expenseAmount: fundChangeItem.expenseAmount,
                  spendAmount: fundChangeItem.spendAmount,
                }
              },
            ) || [],
          total: apiResponse.total,
        }
      })
  }

  /**
   * 客户资金变动曲线图
   */
  function getCustomerFundChangeTrend(params: CustomerFundChangeTrendParams) {
    return requestClient
      .post<CustomerFundChangeTrendItem[]>(
        prefix('customerFundChangeDaily/queryByDate'),
        {
          ...params,
          dateRange: params.dateRange,
        },
      )
      .then((apiResponse) => {
        return {
          walletBalance: apiResponse.map(
            (trendDataItem) => trendDataItem.walletBalance,
          ),
          dates: apiResponse.map((trendDataItem) => trendDataItem.statDate),
          totalNetAssets: apiResponse.map(
            (trendDataItem) => trendDataItem.totalAssetNetValue,
          ),
          walletChangeAmount: apiResponse.map(
            (trendDataItem) => trendDataItem.walletChangeAmount,
          ),
          paymentAmount: apiResponse.map(
            (trendDataItem) => trendDataItem.depositAmount,
          ),
          expenditureAmount: apiResponse.map(
            (trendDataItem) => trendDataItem.expenseAmount,
          ),
          consumptionAmount: apiResponse.map(
            (trendDataItem) => trendDataItem.spendAmount,
          ),
        }
      })
  }

  return {
    getCustomerFundChangeList,
    getCustomerFundChangeTrend,
    getCustomerFundChangeListParams,
  }
})
